import React from "react";
import {observer} from "mobx-react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import { ProfileBoxMessagesIndicator } from "../profile-box-messages-indicator.component";
import {
    TOOLTIP_TARGET_FREE_PLAY_INDICATOR
} from "../../../services/tooltip/on-boarding-tooltip/on-boarding-tooltip-target-selectors";

export const FreePlayIndicatorComponent = observer(class extends OrbitComponent {

    private _onClickHandler = async () => {
        this.services.analytics.sendOrbitUserFlowEvent("Navigation","NavBar", "Open_Rewards");
        (await this.services.userMenu).openRewards();
    }

    public render() {
        return (
            <ProfileBoxMessagesIndicator
                numberOfAwaitingMessages={this.services.freePlay.userVouchersToDisplayInUI.length}
                className = {TOOLTIP_TARGET_FREE_PLAY_INDICATOR}
                iconComponent = {this.services.theme.currentTheme.icons.freeplayIcon}
                text = {this.services.translation.translate('FREEPLAY_INDICATOR')}
                onClick={this._onClickHandler}
            />
        );
    }
});
